import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, MenuOptions, MenuItem, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { FaBroom, FaLink } from "react-icons/fa";

import { IoMdMore, IoIosCreate } from "react-icons/io";
import { FaBolt, FaRegFileAlt, FaTools, FaUtensils, FaHouseDamage, FaHandshake, FaQuestionCircle, FaRupeeSign, FaExclamationCircle, FaRunning } from 'react-icons/fa';
import { GiExpense, GiWashingMachine } from "react-icons/gi";
import { GrVmMaintenance } from "react-icons/gr";
import { FiEdit2 } from "react-icons/fi";

const Table = ({
    apiData,
    setIsEditExtraCharges,
    setShowLinkUnlinkModel,
    setSelectedData,
    setIsDeleteCharges,

}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const deleteCharges = (item) => {
        setIsDeleteCharges(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const edit = (item) => {
        setIsEditExtraCharges(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const linkUnlink = (item) => {
        setShowLinkUnlinkModel(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        const openMenu = (id) => {
            setPreviousId(openActionMenu);
            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.id && (
                    <MenuOptions id="menuOptions">

                        <MenuItem title="Edit Extra Charges" onClick={() => edit(item)}>
                            <FiEdit2 className="text-gray-700 mr-2" /> Edit
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                linkUnlink(item)
                            }}
                        >
                            <FaLink className="text-gray-700 " /> Link - Unlink
                        </MenuItem>
                        <MenuItem title="Delete Extra Charges" onClick={() => deleteCharges(item)}>
                            <MdDelete className="text-gray-700 mr-2" /> Delete Charges
                        </MenuItem>
                    </MenuOptions>
                )}
                <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
                    <IoMdMore className="text-gray-600" size={24} />
                </Btn>
            </ActionBtnWrapper>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                amount: <Amount>{'₹' + item.amount}</Amount>,
                type: getType(item.type),
                repetition: getRepetition(item.repetitionType),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const getRepetition = (type) => {
        const isMonthly = type !== 1;

        return (
            <span
                className={`text-xs font-medium px-2.5 py-1 rounded-full
        ${isMonthly
                        ? "bg-blue-50 text-blue-700"
                        : "bg-gray-100 text-gray-600"
                    }`}
            >
                {isMonthly ? "Monthly" : "One-Time"}
            </span>
        );
    };


    const getType = (type) => {
        if (type === 4) {
            return (
                <TypeWrapper>
                    <FaBolt className="text-blue-500 mr-2 w-5 h-5" />
                    <TypeLabel>Electricity</TypeLabel>
                </TypeWrapper>
            );
        } else if (type === 5) {
            return (
                <TypeWrapper>
                    <FaRegFileAlt className="text-green-500 mr-2 w-5 h-5" />
                    <TypeLabel>Registration</TypeLabel>
                </TypeWrapper>
            );
        } else if (type === 6) {
            return (
                <TypeWrapper>
                    <FaTools className="text-yellow-500 mr-2 w-5 h-5" />
                    <TypeLabel>Tech Charges</TypeLabel>
                </TypeWrapper>
            );
        } else if (type === 9) {
            return (
                <TypeWrapper>
                    <FaUtensils className="text-red-500 mr-2 w-5 h-5" />
                    <TypeLabel>Food</TypeLabel>
                </TypeWrapper>
            );
        } else if (type === 3) {
            return (
                <TypeWrapper>
                    <GrVmMaintenance className="text-teal-500 mr-2 w-5 h-5" />
                    <TypeLabel>Maintenance</TypeLabel>
                </TypeWrapper>
            );
        } else if (type === 8) {
            return (
                <TypeWrapper>
                    <FaHandshake className="text-purple-500 mr-2 w-5 h-5" />
                    <TypeLabel>Agreement Charges</TypeLabel>
                </TypeWrapper>
            );
        } else if (type === 10) {
            return (
                <TypeWrapper>
                    <FaExclamationCircle className="text-purple-500 mr-2 w-5 h-5" />
                    <TypeLabel>Fine</TypeLabel>
                </TypeWrapper>
            );
        }
        else if (type === 19) {
            return (
                <TypeWrapper>
                    <FaRunning className="text-rose-500 mr-2 w-5 h-5" />
                    <TypeLabel>Move Out Charges</TypeLabel>
                </TypeWrapper>
            );
        }
        else if (type === 14) {
            return (
                <TypeWrapper>
                    <FaBroom className="text-teal-500 mr-2 w-5 h-5" />
                    <TypeLabel>Maid Charges</TypeLabel>
                </TypeWrapper>
            );
        }
        else if (type === 17) {
            return (
                <TypeWrapper>
                    <GiWashingMachine className="text-blue-500 mr-2 w-5 h-5" />
                    <TypeLabel>Laundry Charges</TypeLabel>
                </TypeWrapper>
            );
        }
        else {
            return (
                <TypeWrapper>
                    <GiExpense className="text-orange-500 mr-2 w-5 h-5" />
                    <TypeLabel>Other</TypeLabel>
                </TypeWrapper>
            );
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {

            return [
                {
                    Header: "Type",
                    accessor: "type",
                },
                {
                    Header: "Amount",
                    accessor: "amount",
                },

            ];
        }
        return [
            {
                Header: "Type",
                accessor: "type",
            },

            {
                Header: "Repetition",
                accessor: "repetition",
            },

            {
                Header: "Amount",
                accessor: "amount",
            },

            {
                Header: "Action",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );


    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">

                                                <li className="flex gap-2">
                                                    <strong>Amount:</strong> {data[rowIndex].amount}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Repetition:</strong> {data[rowIndex].repetition}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const TypeWrapper = tw.div`
  flex items-center gap-3
`;

const TypeLabel = tw.p`
  text-sm font-medium text-gray-800
`;

const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`
  text-gray-800
  font-semibold
  text-sm
  bg-neutral-100
  px-3
  py-1
  rounded-full
  inline-flex
`;

export default Table;
